export default "__VITE_ASSET__26fb49f4__"